export const ENABLE_PORTAL = 'app/MANAGE_PROPERTIES/PROPERTY/ENABLE_PORTAL';
export const DISABLE_PORTAL = 'app/MANAGE_PROPERTIES/PROPERTY/DISABLE_PORTAL';
export const ONBOARD_PORTAL = 'app/MANAGE_PROPERTIES/PROPERTY/ONBOARD_PORTAL';

export const FORM_NAME = 'PropertyPortalForm';
